import http from '../utils/http';
import getCookieValue from '../utils/get-cookie-value';

const SIGNUP_PREFERENCES_COOKIE_NAME = 'signup_preferences';
const SIGNUP_REFERER_PREFERENCE = 'signup_referer';

const getSignupRefererFromCookies = () => {
  const cookieValue = getCookieValue(SIGNUP_PREFERENCES_COOKIE_NAME);
  if (!cookieValue) return null;

  try {
    const params = new URLSearchParams(cookieValue);
    return params.get(SIGNUP_REFERER_PREFERENCE);
  } catch (e) {
    return null;
  }
}

export default () => {
  const signupReferer = getSignupRefererFromCookies();
  const data = {
    domain: window.location.hostname,
    ...(signupReferer && { signup_referer: signupReferer }),
  };

  return http.post('/feature-flag-service/pb/calculate-visitor-feature-flags/', data);
}
